import { memo } from "react";

import { List } from "@snapchat/snap-design-system";

import { LoadMore } from "../../common/components";
import { DashboardSpinner } from "../../dashboard/components/DashboardSpinner";
import { type GroupsGridItemModel } from "../grid/model";

import { GroupsListItem } from "./GroupsListItem";
import { NoResults } from "./NoResults";

interface GroupsListProps {
    onLoadMore: () => void;
    isLoading: boolean;
    groups: readonly GroupsGridItemModel[];
    selectedGroups: ReadonlyMap<string, GroupsGridItemModel>;
    isLastPage: boolean;
    toggleSelection: (group: GroupsGridItemModel) => void;
    newGroups: ReadonlySet<string>;
}

export const GroupsList = memo<GroupsListProps>(
    ({ groups, isLoading, onLoadMore, isLastPage, selectedGroups, toggleSelection, newGroups }) => {
        if (isLoading && groups.length === 0) {
            return <DashboardSpinner />;
        }

        if (groups.length === 0) {
            return <NoResults description="You don't have any groups yet or try to change search criteria." />;
        }

        return (
            <>
                <List>
                    {groups.map((group) => (
                        <List.Item key={group.id}>
                            <GroupsListItem
                                group={group}
                                toggleSelection={toggleSelection}
                                isSelected={selectedGroups.has(group.id as string)}
                                isNew={newGroups.has(group.id as string)}
                            />
                        </List.Item>
                    ))}
                </List>
                <LoadMore onClick={onLoadMore} loading={isLoading} isLastPage={isLastPage} />
            </>
        );
    },
);
